// libs
import React, { useCallback } from 'react';

import { cn } from '@lyearn/style';
// components
import { Checkbox, Stack } from '@lyearn/ui';
import * as User from '@/components/User';

import { disabledCheckbox } from './styles';
// types
import { ListItemProps } from './types';

function ListItem(props: ListItemProps) {
  const { user, onSelect, selected, disabled, profilePictureSize = 48, classes } = props;

  const _onSelect = useCallback(() => {
    onSelect(user.id);
  }, [onSelect, user.id]);

  return (
    <Stack
      alignItems="center"
      aria-label={user.name!}
      className={cn(
        'flex-shrink-0 border-b border-divider py-16 ps-16 pe-20',
        {
          'pointer-events-none': disabled,
        },
        classes?.container,
      )}
      justifyContent="between"
      role="button"
      onClick={disabled ? undefined : _onSelect}>
      <User.Provider alignItems="center" className="flex items-center space-s-16" user={user}>
        <User.ProfilePicture size={profilePictureSize} />
        <Stack direction="col" gapY={2}>
          <User.Name color="text-text-primary" variant="body-short-01" />
          <User.UniqueId variant="body-short-02" />
        </Stack>
      </User.Provider>
      <Checkbox
        checked={selected}
        className={disabled ? disabledCheckbox : ''}
        disabled={disabled}
      />
    </Stack>
  );
}

export default ListItem;
